import React from "react";

import { LinkText, ColumnStyle } from "components/Common/TableStyle";

export const STEWARD_TABLE_COLUMN = () => [
  {
    title: "Name",
    dataIndex: "name",
    key: "name",
    fixed: "left",
    width: "25%",
    render: (text, row) => (
      <LinkText text={text} link={row.key} state={{ parent: text }} />
    ),
  },
  {
    title: "Role",
    dataIndex: "role",
    key: "role",
    width: "25%",
    render: text => <ColumnStyle text={text} />,
  },
  {
    title: "Phone",
    dataIndex: "phone",
    key: "phone",
    width: "25%",
    render: () => (
      <ColumnStyle text={`9${Math.floor(Math.random() * 1000000000)}`} />
    ),
  },
  {
    title: "Email Address",
    dataIndex: "email",
    key: "email",
    width: "25%",
    render: text => <ColumnStyle text={text} />,
  },
];

export const QUICK_FILTER_DATA = (
  setFilter,
  dataStewardsCount,
  applicationStewardsCount,
  InformationGovernorCount
) => [
  {
    label: "Data Stewards",
    value: dataStewardsCount,
    onClick: () =>
      setFilter({
        filterBy: "role @>",
        filterValue: '[{"name":"data_steward"}]',
      }),
  },
  {
    label: "Application Stewards",
    value: applicationStewardsCount,
    onClick: () =>
      setFilter({
        filterBy: "role @>",
        filterValue: '[{"name":"application_steward"}]',
      }),
  },
  {
    label: "Information Governor",
    value: InformationGovernorCount,
    onClick: () =>
      setFilter({
        filterBy: "role @>",
        filterValue: '[{"name":"information_governor"}]',
      }),
  },
];

export const SUMMARY_GRAPH_DATA = [
  {
    "Resources count": 0,
  },
  {
    "Resources count": 3000,
  },
  {
    "Resources count": 2000,
  },
  {
    "Resources count": 2780,
  },
  {
    "Resources count": 1890,
  },
  {
    "Resources count": 2390,
  },
  {
    "Resources count": 3490,
  },
];
